import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, formatApiError } from "@/context/AuthContext";
import { FOUNDATION } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, admin, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!loading && admin) navigate("/admin");
  }, [admin, loading, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "लॉगिन विफल");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen sunburst-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-8">
          <img src={FOUNDATION.logo} alt="logo" className="w-20 h-20 rounded-full object-cover mx-auto ring-2 ring-amber-300" />
          <h1 className="font-display text-2xl text-[#0a2540] mt-4">प्रबंधक लॉगिन</h1>
          <p className="text-sm text-slate-500 font-eng mt-1">{FOUNDATION.nameEng} — Admin</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-[#0a2540]">ईमेल</Label>
            <Input data-testid="admin-login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 border-amber-200" placeholder="admin email" autoComplete="username" />
          </div>
          <div>
            <Label className="text-[#0a2540]">पासवर्ड</Label>
            <Input data-testid="admin-login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 border-amber-200" placeholder="password" autoComplete="current-password" />
          </div>
          {error && <p className="text-sm text-red-600 bg-red-50 rounded-md p-2" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="admin-login-submit-button" className="w-full bg-[#0a2540] hover:bg-[#061729] h-11 gap-2">
            <Lock size={16} /> {busy ? "लॉगिन हो रहा है..." : "लॉगिन करें"}
          </Button>
        </form>
        <button onClick={() => navigate("/")} className="text-sm text-slate-500 hover:text-amber-700 mt-6 mx-auto block">
          ← वेबसाइट पर वापस जाएं
        </button>
      </div>
    </div>
  );
}
